import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { ChartOfAccountStyles } from "../Chart-Of-Account/ChartOfAccountShared";
import JournalCodeForm from "./JournalCodeForm";

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [saving, setSaving] = useState(false);
  const { checkRequiredFields } = useRequiredFields();

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // Suggest the next free code; merged in so anything typed first survives.
  useEffect(() => {
    Http.get("/last-code-increment-by-one/acc_journal_codes/code/JC").then(
      (res) => {
        setInputs((values) => ({ code: res.data, ...values }));
      },
    );
  }, []);

  const formSubmit = () => {
    if (saving || !checkRequiredFields()) {
      return;
    }

    setSaving(true);
    Http.post("/journal-code", inputs)
      .then((res) => {
        navigate("/journal-code", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch((e) => {
        setSaving(false);
        setError(
          e.response?.data?.errors || {
            general: [
              e.response?.data?.message ||
                "Could not save the journal code. Please try again.",
            ],
          },
        );
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <ChartOfAccountStyles />
        <div className="am-pagetitle">
          <div>
            <h5 className="am-title mb-1">Create Journal Code</h5>
            <p className="text-muted mb-0 tx-12">
              Add a code to group journal vouchers under
            </p>
          </div>
          <Link to="/journal-code" className="btn btn-outline-secondary">
            <i className="fa fa-arrow-left mg-r-6"></i>Back to List
          </Link>
        </div>

        <div className="am-pagebody">
          <div className="row">
            <div className="col-lg">
              <FormValidation error={error} />
            </div>
          </div>

          <JournalCodeForm
            inputs={inputs}
            onChange={handleChange}
            onSubmit={formSubmit}
            saving={saving}
            submitLabel="Create Journal Code"
            savingLabel="Saving..."
            codeHint="Next free code. You may change it."
          />
        </div>
      </div>
    </div>
  );
};

export default Create;
